export function formatPetInfo (petInfo) {
  return petInfo?.map(p => ({
    ownerName: p.ownerName,
    breed: p.breed,
    petWeight: p.petWeight
  }))
}
